import { type ReactElement, useState, FormEvent, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm, SubmitHandler } from "react-hook-form";
import { AppDispatch, RootState } from "src/app/store";
import { resetPassword } from "../hooks/resetPassword";
import passwordImage from "../../../assests/Icons/lock.svg";

type LoginFields = {
        FirstName: string;
        LastName: string;
        EmailId: string;
        Password: string;
        ConfirmPassword: string;
        PhoneNumber: string;
        ProfileId: number;
        UserType: number;
}

export default function ResetPasswordForm(): ReactElement {
        const { register, watch, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm<LoginFields>();
        const dispatch = useDispatch<AppDispatch>();
        const { resetPasswordError, response } = useSelector((state: RootState) => state.resetPassword);
        const navigate = useNavigate();
        const location = useLocation();
        const queryString = location.search;
        const queryParams = new URLSearchParams(queryString);
        const token = queryParams.get('token');

        const onSubmit: SubmitHandler<LoginFields> = async (data) => {
                await dispatch(resetPassword({ data, token }));
        }

        useEffect(() => {
                if (response !== null) {
                        navigate('/');
                }
                if (resetPasswordError !== null) {
                        setError("root", {
                                message: resetPasswordError,
                        })
                }
                if (token == null) {
                        navigate('/');
                }
        }, [resetPasswordError, response])

        return <>
                <div className="w-full p-6 max-md:max-w-lg mx-auto">
                        <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-8">
                                        <h3 className="text-gray-800 text-3xl font-bold">Reset Password</h3>
                                </div>

                                <div className="mt-4">
                                        <label className="text-gray-800 text-[15px] mb-2 block">Password</label>
                                        <div className="relative flex items-center">
                                                <input type="password" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter password" {...register("Password", { required: "Password is required", minLength: { value: 8, message: "Password must be atleast 8 characters" }, })} />
                                                <img src={passwordImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.Password && (
                                                <div className="text-red-500">{errors.Password.message}</div>
                                        )}
                                </div>
                                <div className="mt-4">
                                        <label className="text-gray-800 text-[15px] mb-2 block">Confirm Password</label>
                                        <div className="relative flex items-center">
                                                <input type="password" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter password" {...register("ConfirmPassword", {
                                                        required: "Confirm Password is required", validate: (value: string) => {
                                                                if (watch('Password') !== watch('ConfirmPassword')) {
                                                                        return "The Passwords do not match";
                                                                }
                                                        },
                                                })} />
                                                <img src={passwordImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.ConfirmPassword && (
                                                <div className="text-red-500">{errors.ConfirmPassword.message}</div>
                                        )}
                                </div>
                                <div className="mt-8">
                                        <button disabled={isSubmitting} type="submit" className="w-full py-3 px-4 text-sm tracking-wide rounded-xs text-white bg-blue-600 hover:bg-blue-700 focus:outline-none">
                                                {isSubmitting ? "Saving..." : "Save"}
                                        </button>
                                </div>
                        </form>
                        {errors.root && (
                                <div className="flex justify-center font-bold text-red-500 pt-4">{errors.root.message}</div>
                        )}
                </div>
        </>
}
